import { initialListPaginationMeta } from "utils/helpers/pagination";

import {
  FrontClearanceFilterEnum,
  FrontClearanceFilterOptions,
  FrontClearanceForm,
  FrontClearanceFormDropDownState,
  FrontClearanceState,
} from "../types";

export const initialFrontClearanceForm: FrontClearanceForm = {
  manufacturer: "",
  masterModel: "",
  year: "",
  driverCabin: "",
  bodyType: "",
  optimalDistance: "",
  minimalDistance: "",
  note: "",
};

export const initialFrontClearanceMeta = initialListPaginationMeta;

export const initialFilterOptions: FrontClearanceFilterOptions = {
  [FrontClearanceFilterEnum.Manufacturers]: [],
  [FrontClearanceFilterEnum.Models]: [],
  [FrontClearanceFilterEnum.SuperModels]: [],
  [FrontClearanceFilterEnum.Years]: [],
};

export const initialFormDropDownState: FrontClearanceFormDropDownState = {
  items: [],
  page: 1,
  perPage: 20,
  meta: initialFrontClearanceMeta,
  loading: false,
};

export const initialState: FrontClearanceState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialFrontClearanceMeta,
  error: null,
  manufacturerFilter: "ALL",
  masterModelFilter: "ALL",
  yearFilter: "ALL",
  filterOptions: initialFilterOptions,
  filterOptionsLoading: false,
  filterOptionsError: null,
  isAddModalOpen: false,
  form: initialFrontClearanceForm,
  formDropDowns: {
    manufacturers: { ...initialFormDropDownState },
    superModels: { ...initialFormDropDownState },
  },
};
